export default __webpack_public_path__ + "media/images/elephant_ui_plane-a641adfd92dd47ffce70680d5f338d49.svg";